<template>
  <div>
    <form id="search-form" @submit.prevent="submitQuery">
      <div>
        <textarea
          onload="this.focus()"
          type="text"
          name="q"
          class="inputarea card-animate-2"
          placeholder="Describe your case objectives here:"
          v-model="queryPrompt"
          rows="4"
          cols="500"
          @keyup.enter="submitQuery"
        ></textarea>
      </div>
      <div>
        <v-row>
          <v-col cols="12" md="12">
            <div v-if="abducteeImage" class="abductee-image-container">
    <img :src="abducteeImage" alt="Abductee" />
  </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field class="inputarea2 card-animate-2" v-model="abductee" label="Abductee"></v-text-field>
            <v-switch
              v-model="abductee"
              color="success"
              value=""
              hide-details
              @change="playSound(submitAudio)"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field class="inputarea2 card-animate-2" v-model="abducteedob" label="D.O.B."></v-text-field>
            <v-switch
              v-model="abducteedob"
              color="success"
              value=""
              hide-details
              @change="playSound(submitAudio)"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field class="inputarea2 card-animate-2" v-model="missingSince" label="Missing Since"></v-text-field>
            <v-switch
              v-model="missingSince"
              color="success"
              value=""
              hide-details
              @change="playSound(submitAudio)"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field class="inputarea2 card-animate-2" v-model="abductor" label="Abductor"></v-text-field>
            <v-switch
              v-model="abductor"
              color="success"
              value=""
              hide-details
              @change="playSound(submitAudio)"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field class="inputarea2 card-animate-2" v-model="familyCountry" label="Family Country"></v-text-field>
            <v-switch
              v-model="familyCountry"
              color="success"
              value=""
              hide-details
              @change="playSound(submitAudio)"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field class="inputarea2 card-animate-2" v-model="abducteeSocialMedia" label="Abductee Social Media Profiles"></v-text-field>
            <v-switch
              v-model="abducteeSocialMedia"
              color="success"
              value=""
              hide-details
              @change="playSound(submitAudio)"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field class="inputarea2 card-animate-2" v-model="abductorSocialMedia" label="Abductor Social Media Profiles"></v-text-field>
            <v-switch
              v-model="abductorSocialMedia"
              color="success"
              value=""
              hide-details
              @change="playSound(submitAudio)"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field class="inputarea2 card-animate-2" v-model="lastKnownAddress" label="Last Known Address"></v-text-field>
            <v-switch
              v-model="lastKnownAddress"
              color="success"
              value=""
              hide-details
              @change="playSound(submitAudio)"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="3">
            <div class="inputarea2 card-animate-2">
            <label>
              <input type="radio" v-model="caseType" value="International" />
              International
            </label>
            <label>
              <input type="radio" v-model="caseType" value="Domestic" />
              Domestic
            </label>
            <v-switch
              v-model="caseType"
              color="success"
              value=""
              hide-details
              @change="playSound(submitAudio)"
            ></v-switch>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <input type="file" @change="uploadImage" accept="image/*">
          </v-col>
        </v-row>
      </div>
      <br />
      <br />
      <div>
        <v-btn class="mx-2" type="submit" value="Submit">Submit</v-btn>
        <v-btn class="mx-2" type="submit" value="Reset" @click="resetDialogue">Reset</v-btn>
        <v-btn v-if="editingQueryIndex !== -1" class="mx-2" type="submit" value="Update" @click="updateQuery">Update</v-btn>
      </div>
    </form>

    <div id="dialogueResults">
      <p v-for="(entry, index) in dialogueHistory" :key="index" v-html="entry"></p>
    </div>
    <br />
    <div v-if="loading" class="loading-container">
      <img class="mx-auto d-block" style="height: 25%; width: 25%" src="../assets/images/loading-spinner15.gif" alt="Loading" />
      <br />
      <p>{{ loadingText }}</p>
    </div>
    <div v-if="foundDataMessage" class="found-data-message">{{ foundDataMessage }}</div>
    <div v-if="actionSteps.length">
      <p>Recommended Action Steps:</p>
      <ul>
        <li v-for="(step, index) in actionSteps" :key="index">{{ step }}</li>
      </ul>
    </div>
    <div>
      <v-btn class="mx-2" @click="saveQuery">Save Query</v-btn>
      <v-btn class="mx-2" @click="saveResearch">Save Research</v-btn>
    </div>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <v-divider></v-divider>
    <saved-query-list
      :saved-queries="savedQueries"
      @edit-query="editSavedQuery"
      @delete-query="deleteSavedQuery"
    ></saved-query-list>
  <br />
  <saved-research-list
      :saved-researches="savedResearches"
      @delete-research="deleteSavedResearch"
    ></saved-research-list>
  </div>
</template>
<script>
import inputAudio from '../assets/audio/SelectNew.wav';
import submitAudio from '../assets/audio/input1.wav';
import thinkingAudio from '../assets/audio/Wave.wav';
import codeCompleteAudio from "../assets/audio/input4.wav";
import SavedQueryList from "./SavedQueryList.vue";
import SavedResearchList from "./SavedResearchList.vue";
export default {
  components: {
    SavedQueryList,
    SavedResearchList,
  },
  data() {
    return {
      abducteeImage: null, // Add this new data property
      abductee: "",
      abducteedob: "",
      abductor: "",
      familyCountry: "",
      missingSince: "",
      abducteeSocialMedia: "",
      abductorSocialMedia: "",
      lastKnownAddress: "",
      caseType: "",
      lastSavedQuery: "",
      lastSavedUrl: "",
      continuousMode: false,
      loading: false,
      loadingText: "",
      queryPrompt: "",
      dialogueHistory: [],
      actionSteps: [],
      currentActionIndex: 0,
      objectivesAchieved: false,
      savedQueries: [],
      savedResearches: [],
      foundDataMessage: "",
      editingQueryIndex: -1,
      inputAudio,
      submitAudio,
      thinkingAudio,
      codeCompleteAudio,
    };
  },
  mounted() {
    const storedsavedQueries = JSON.parse(localStorage.getItem("savedQueries"));
    if (storedsavedQueries) {
      this.savedQueries = storedsavedQueries;
    }

    const storedsavedResearches = JSON.parse(localStorage.getItem("savedResearches"));
    if (storedsavedResearches) {
      this.savedResearches = storedsavedResearches;
    }

    this.codeEditor.on("change", () => {
      const code = this.codeEditor.getValue();
      document.getElementById("outputIframe").srcdoc = code;
    });
  },
  watch: {
    dialogueHistory() {
      const code = this.dialogueHistory
        .map(entry => entry.text.replace(/<\/?[^>]+(>|$)/g, ""))
        .join("\n");
      this.codeEditor.setValue(code, 1);
      document.getElementById("outputIframe").srcdoc = code;
    },
  },
  methods: {
    async uploadImage(event) {
  const file = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      this.abducteeImage = e.target.result;
      this.savedResearches.push({ image: this.abducteeImage });
      localStorage.setItem("savedResearches", JSON.stringify(this.savedResearches));
    };
    reader.readAsDataURL(file);
  }
},
    async downloadImage(imageUrl) {
      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        this.abducteeImage = objectUrl;
      } catch (error) {
        console.error("Failed to download image:", error);
      }
    },
    async submitQuery() {
      if (!this.queryPrompt) return;

      // Combine all input fields into a single query
      const inputData = [
        `Abductee: ${this.abductee}`,
        `D.O.B: ${this.abducteedob}`,
        `Abductor: ${this.abductor}`,
        `Family Country: ${this.familyCountry}`,
        `Missing Since: ${this.missingSince}`,
        `Abductee Social Media Profiles: ${this.abducteeSocialMedia}`,
        `Abductor Social Media Profiles: ${this.abductorSocialMedia}`,
        `Last Known Address: ${this.lastKnownAddress}`,
        `Case Type: ${this.caseType}`,
      ].join("\n");

      this.queryPrompt = `${this.queryPrompt}\n${inputData}`;


      this.dialogueHistory.push(`<strong>User:</strong> ${this.queryPrompt}`);
      window.scrollTo(0, 740);
      new Audio(submitAudio).play();
      // Show loading spinner and "Thinking" text
      this.loading = true;
      this.loadingText = "Thinking...";
      this.readOutLoud('Thinking...');
      setTimeout(() => {
        this.loadingText = "Researching... (This may take a moment)";
        this.readOutLoud('Researching... this may take a moment');
        new Audio(thinkingAudio).play();
      }, 5000); // Show the longer text after 5 seconds
      try {
        const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ message: this.queryPrompt }),
        });
        this.loadingText = "Generating abduction case research results...";
        this.readOutLoud('Generating abduction case research results...');
        const content = await response.json();
        new Audio(codeCompleteAudio).play();

        this.loading = false;
        this.loadingText = "Executing action to achieve objective: " + content.message;

        this.dialogueHistory.push(`<strong>AI:</strong> ${content.message}`);
        const responseUrl = content.url;

        if (responseUrl) {
          const leftOfCenter = window.innerWidth / 2 - 450;
          window.open(responseUrl, "_blank", `left=${leftOfCenter}`);
          this.lastSavedUrl = responseUrl;
          this.downloadImage(responseUrl);
        }
        this.processFoundData(content);
        window.scrollTo(0, 140);
        this.actionSteps = content.actionSteps || []; // Example: ['Step 1', 'Step 2', 'Step 3']
        this.currentActionIndex = 0;
        this.objectivesAchieved = false;

        this.queryPrompt = "";
      } catch (err) {
        console.error(err);
      }
    },
    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    processFoundData(content) {
      // Extract the found data from content and update the input fields accordingly

      // Example: If content contains "Abductee: John Doe", update the abductee input field
      const regexes = [
    { field: 'abductee', regex: /Abductee:\s*(.+)/i },
    { field: 'abducteedob', regex: /D.O.B:\s*(.+)/i },
    { field: 'abductor', regex: /Abductor:\s*(.+)/i },
    { field: 'familyCountry', regex: /Family Country:\s*(.+)/i },
    { field: 'missingSince', regex: /Missing Since:\s*(.+)/i },
    { field: 'abducteeSocialMedia', regex: /Abductee Social Media Profiles:\s*(.+)/i },
    { field: 'abductorSocialMedia', regex: /Abductor Social Media Profiles:\s*(.+)/i },
    { field: 'lastKnownAddress', regex: /Last Known Address:\s*(.+)/i },
    { field: 'caseType', regex: /Case Type:\s*(.+)/i },
  ];

  for (const { field, regex } of regexes) {
    const match = content.message.match(regex);
    if (match && !this[field]) {
      this[field] = match[1];
      this.showFoundDataMessage(field);
    }
  }
      const abducteeRegex = /Abductee:\s*(.+)/i;
      const abducteeMatch = content.message.match(abducteeRegex);
      if (abducteeMatch && !this.abductee) {
        this.abductee = abducteeMatch[1];
        this.showFoundDataMessage("Abductee");
      }
      const abducteedobRegex = /D.O.B:\s*(.+)/i;
      const abducteedobMatch = content.message.match(abducteedobRegex);
      if (abducteedobMatch && !this.abducteedob) {
        this.abducteedob = abducteedobMatch[1];
        this.showFoundDataMessage("D.O.B");
      }
      const abductorRegex = /Abductor:\s*(.+)/i;
      const abductorMatch = content.message.match(abductorRegex);
      if (abductorMatch && !this.abductor) {
        this.abductor = abductorMatch[1];
        this.showFoundDataMessage("Abductor");
      }
      const countryRegex = /Family Country:\s*(.+)/i;
      const countryMatch = content.message.match(countryRegex);
      if (countryMatch && !this.familyCountry) {
        this.familyCountry = countryMatch[1];
        this.showFoundDataMessage("Family Country");
      }
      const missingRegex = /Missing Since:\s*(.+)/i;
      const missingMatch = content.message.match(missingRegex);
      if (missingMatch && !this.missingSince) {
        this.missingSince = missingMatch[1];
        this.showFoundDataMessage("Missing Since");
      }
      const abducteesmRegex = /Abductee Social Media Profiles:\s*(.+)/i;
      const abducteesmMatch = content.message.match(abducteesmRegex);
      if (abducteesmMatch && !this.abducteeSocialMedia) {
        this.abducteeSocialMedia = abducteesmMatch[1];
        this.showFoundDataMessage("Abductee Social Media Profiles");
      }
      const abductorsmRegex = /Abductor Social Media Profiles:\s*(.+)/i;
      const abductorsmMatch = content.message.match(abductorsmRegex);
      if (abductorsmMatch && !this.abductorSocialMedia) {
        this.abductorSocialMedia = abductorsmMatch[1];
        this.showFoundDataMessage("Abductor Social Media Profiles");
      }
      else if (abductorsmMatch && !this.abductorSocialMedia) {
        this.abductorSocialMedia = abductorsmMatch[0];
        this.showFoundDataMessage("Abductor Social Media Profiles");
      }
      const lastKnownAddressRegex = /Last Known Address:\s*(.+)/i;
      const lastKnownAddressMatch = content.message.match(lastKnownAddressRegex);
      if (lastKnownAddressMatch && !this.lastKnownAddress) {
        this.lastKnownAddress = lastKnownAddressMatch[1];
        this.showFoundDataMessage("Last Known Address");
      }
      const caseTypeRegex = /Case Type:\s*(.+)/i;
      const caseTypeMatch = content.message.match(caseTypeRegex);
      if (caseTypeMatch && !this.caseType) {
        this.caseType = caseTypeMatch[1];
        this.showFoundDataMessage("Case Type");
      }
    },
    showFoundDataMessage(fieldName) {
      this.foundDataMessage = `Found data for ${fieldName}`;
      setTimeout(() => {
        this.foundDataMessage = "";
      }, 3000); // Close the message after 3 seconds
    },
    resetDialogue() {
    this.queryPrompt = '';
    this.dialogueHistory = [];
    this.actionSteps = [];
    this.currentActionIndex = 0;
    this.objectivesAchieved = false;
  },
  approveAction() {
    // Execute the current action and move to the next recommended action
    this.executeAction(this.actionSteps[this.currentActionIndex]);
    this.nextRecommendedAction();
  },
  nextRecommendedAction() {
      if (this.currentActionIndex < this.actionSteps.length - 1) {
        this.currentActionIndex++;
      } else {
        this.currentActionIndex = 0;
      }
    },
  executeContinuousMode() {
    this.continuousMode = !this.continuousMode; // Toggle continuous mode

    if (this.continuousMode) {
      for (const step of this.actionSteps) {
        this.executeAction(step);
      }

      this.objectivesAchieved = true;
    }
  },
  executeAction(action) {
    // Implement the logic to execute the action, such as interacting with the opened web page
    console.log(`Executing action: ${action}`);
  },
  saveQuery() {
      if (this.editingQueryIndex === -1) {
        this.savedQueries.push(this.queryPrompt);
      } else {
        this.savedQueries[this.editingQueryIndex] = this.queryPrompt;
        this.editingQueryIndex = -1;
      }
      localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
    },
    updateQuery() {
      if (this.editingQueryIndex !== -1) {
        this.savedQueries[this.editingQueryIndex] = this.queryPrompt;
        this.editingQueryIndex = -1;
        localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
      }
    },
    saveResearch() {
  const researchData = {
    abductee: this.abductee,
    abducteedob: this.abducteedob,
    abductor: this.abductor,
    familyCountry: this.familyCountry,
    missingSince: this.missingSince,
    abducteeSocialMedia: this.abducteeSocialMedia,
    abductorSocialMedia: this.abductorSocialMedia,
    lastKnownAddress: this.lastKnownAddress,
    caseType: this.caseType,
    lastSavedQuery: this.queryPrompt,
    lastSavedUrl: this.lastSavedUrl,
    date: new Date().toLocaleString(),
    dialogue: this.dialogueHistory, // Add this line to save dialogue history
  };
  this.savedResearches.push(researchData);
  localStorage.setItem("savedResearches", JSON.stringify(this.savedResearches));
},
    editSavedQuery(index) {
      this.queryPrompt = this.savedQueries[index];
      this.editingQueryIndex = index;
      if (this.lastSavedUrl) {
        window.open(this.lastSavedUrl, "_blank");
      }
      this.dialogueHistory.push(`<strong>User:</strong> ${this.queryPrompt}`);
    },
    deleteSavedQuery(index) {
      this.savedQueries.splice(index, 1);
      localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
    },
    deleteSavedResearch(index) {
      this.savedResearches.splice(index, 1);
      localStorage.setItem("savedResearches", JSON.stringify(this.savedResearches));
    },
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);

    },
  },
};
</script>



<style>
.found-data-message {
  background-color: #4caf50;
  color: white;
  padding: 12px;
  margin: 10px 0;
  border-radius: 4px;
}
.ace_cursor {
  border-right: 0.15em solid orange;
  animation: blink-caret 0.5s step-end infinite;
}

/* The typewriter cursor effect */
@keyframes blink-caret {
  from,
  to {
    border-color: transparent;
  }
  50% {
    border-color: orange;
  }
}
.ace_line {
  white-space: nowrap;
  margin: 0 auto;
  letter-spacing: 0.15em;
  animation: typing 0.0001s steps(200, end);
}

/* The typing effect */
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 5px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: normal;
  font-family: Arimo, sans-serif;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
@media only screen and (max-width: 900px) {
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
}
.inputarea {
  width: 100%;
  height: 100%;
  overflow: auto;
  scroll-margin-bottom: 10px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 16px;
  resize: none;
}
.inputarea2 {
  width: 100%;
  height: 80px;
  padding: 20px 20px;
  box-sizing: border-box;
  border: 1px solid #37a877;
  border-radius: 15px;
  margin: 10px 15px;
  background-color: #f8f8f800;
  font-size: 16px;
  resize: none;
}

#codeEditor {
    width: 100%;
    height: 400px;
}
  #outputIframe {
    width: 100%;
    height: 400px;
    border: 1px solid #ccc;
  }
  
  #dialogueResults {
    padding: 10px;
    border: 1px solid #ccc;
    margin-bottom: 10px;
    max-height: 200px;
    overflow-y: auto;
  }
  #savedProjects {
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  max-height: 200px;
  overflow-y: auto;
}
</style>
